import { Accents, Component, Icons, Knobs, Story } from './DocTypes';

const knobs: Knobs = {
  heading: {
    default: 'My Beautiful App',
    editor: 'textbox',
  },
  headingAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  accent: {
    default: 'dolphinblue',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  icon: {
    default: 'Search',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  iconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  option1: {
    default: '',
    editor: 'textbox',
  },
  option1Icon: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  option2: {
    default: '',
    editor: 'textbox',
  },
  option2Icon: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  data1: {
    default: '',
    editor: 'textbox',
  },
  data1Icon: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  data2: {
    default: '',
    editor: 'textbox',
  },
  data2Icon: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  menuButtonIconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const v1Knobs: Knobs = {
  ...knobs,
  option1Accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  option2Accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  data1Accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  data2Accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const v3Knobs: Knobs = {
  ...knobs,
  option1IconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  option2IconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  data1IconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  data2IconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const SingleStory: Story = {
  title: 'Single',
  description: 'A single app header',
  coreComponent: {
    html: `<tag-app-header {{...knobs}}>
      <div slot='menu'>
        <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>`,
    knobs: v1Knobs,
  },
  reactWrapper: {
    jsx: `<TagAppHeader
      {{...knobs}}
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
    knobs: v1Knobs,
  },
  coreComponent_v3: {
    html: `<tag3-app-header {{...knobs}}>
      <div slot='menu'>
        <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag3-menu-item>
      </div>
    </tag3-app-header>`,
    knobs: v3Knobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader {{...knobs}}   menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}>
    </Tag3AppHeader>`,
    knobs: v3Knobs,
  },
};

const DoubleStory: Story = {
  title: 'Double',
  description: 'A double app header',
  coreComponent: {
    html: `<tag-app-header heading='My Beautiful App' icon='Search' accent='dolphinblue'>
  <div slot='menu'>
    <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
  </div>
  <div slot='content' style='display:flex; align-items: center; margin: 5px 20px 0 7px;'>
    <tag-text type='span' text='Level' accent='title' style='font-size: 18px; font-weight: 500'></tag-text>
    <tag-combobox
      text-field='level'
      value-field='level'
      value='Gold'
      borderless
      input-disabled
      input-style='{"background-color": "transparent", "font-weight": "500", "font-size": "18px" }'
      style='margin-left: 5px;width:80px;'
      data-id='level'>
    </tag-combobox>
    <tag-text type='span' text='Financial Year' accent='title' style='margin-left: auto; font-size: 18px; font-weight: 500'></tag-text>
    <tag-combobox
      text-field='year'
      value-field='year'
      value='2018'
      borderless
      input-disabled
      popup-position='bottom-start'
      input-style='{"background-color": "transparent", "font-weight": "700", "font-size": "28px", "margin-top": "-8px"}'
      style='margin-left: 5px; width:70px;'
      data-id='year'>
    </tag-combobox>
  </div>
</tag-app-header>`,
    js: `var yearCombobox = document.querySelector("tag-combobox[data-id='year']");
yearCombobox.componentOnReady().then(function() {
  yearCombobox.data = [{ year: '2018' }, { year: '2017' }, { year: '2016' }];
});
var levelCombobox = document.querySelector("tag-combobox[data-id='level']");
levelCombobox.componentOnReady().then(function() {
  levelCombobox.data = [{ level: 'Gold' }, { level: 'Silver' }, { level: 'Bronze' }];
});`,
    additionalEvents: ['valueChange'],
    knobs: v1Knobs,
  },
  reactWrapper: {
    jsx: `<TagAppHeader
  heading='My Beautiful App'
  icon='Search'
  accent='dolphinblue'
  menuItems={[
    {
      icon: 'Delete',
      name: 'remove',
      text: 'Remove',
    },
  ]}
  >
  <div
  style={{
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px 20px 0 7px',
  }}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <TagText
        type="span"
        text="Level"
        accent="title"
        textStyle={{ fontSize: '18px', fontWeight: 500 }}
      />
      <TagCombobox
        textField="level"
        valueField="level"
        value="Gold"
        borderless={true}
        inputDisabled={true}
        inputStyle={{ backgroundColor: 'transparent', fontWeight: 500, fontSize: '18px' }}
        style={{ marginLeft: '5px', width: '80px' }}
        data-id="level"
        data={[{ level: 'Gold' }, { level: 'Silver' }, { level: 'Bronze' }]}
      />
    </div>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <TagText
        type="span"
        text="Financial Year"
        accent="title"
        textStyle={{ marginLeft: 'auto', fontSize: '18px', fontWeight: 500 }}
      />
      <TagCombobox
        textField="year"
        valueField="year"
        value="2018"
        borderless={true}
        inputDisabled={true}
        inputStyle={{
          backgroundColor: 'transparent',
          fontSize: '28px',
          fontWeight: 700,
          marginTop: '-8px',
        }}
        style={{ marginLeft: '5px', width: '70px' }}
        data-id="year"
        data={[{ year: '2018' }, { year: '2017' }, { year: '2016' }]}
      />
    </div>
  </div>
</TagAppHeader>`,
    knobs: v1Knobs,
  },
  coreComponent_v3: {
    html: `<tag3-app-header {{...knobs}}>
  <div slot='menu'>
    <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag3-menu-item>
  </div>
  <div slot='content' style='display:flex; align-items: center; margin: 5px 20px 0 7px;'>
    <tag3-text text='Level' type="span" accent='title' text-style='{"font-size": "18px", "font-weight": "500"}'></tag3-text>
    <tag-combobox
      text-field='level'
      value-field='level'
      value='Gold'
      borderless
      input-disabled
      input-style='{"background-color": "transparent", "font-weight": "500", "font-size": "18px" }'
      style='margin-left: 5px;width:80px;'
      data-id='level'>
    </tag-combobox>
    <tag3-text text='Financial Year' type="span" accent='title' style="margin-left: auto;" text-style='{"font-size": "18px", "font-weight": "500"}'></tag3-text>
    <tag-combobox
      text-field='year'
      value-field='year'
      value='2018'
      borderless
      input-disabled
      popup-position='bottom-start'
      input-style='{"background-color": "transparent", "font-weight": "700", "font-size": "28px", "margin-top": "-8px"}'
      style='margin-left: 5px; width:70px;'
      data-id='year'>
    </tag-combobox>
  </div>
</tag3-app-header>`,
    js: `var yearCombobox = document.querySelector("tag-combobox[data-id='year']");
  yearCombobox.data = [{ year: '2018' }, { year: '2017' }, { year: '2016' }];
  var levelCombobox = document.querySelector("tag-combobox[data-id='level']");
  levelCombobox.data = [{ level: 'Gold' }, { level: 'Silver' }, { level: 'Bronze' }];
`,
    knobs: v3Knobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader {{...knobs}}   menuItems={[
      {
        icon: 'Delete',
        name: 'remove',
        text: 'Remove',
      },
    ]}>
    <div
    style={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      margin: '5px 20px 0 7px',
    }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tag3Text
          text="Level"
          accent="title"
          textStyle={{ fontSize: '18px', fontWeight: 500 }}
        />
        <TagCombobox
          textField="level"
          valueField="level"
          value="Gold"
          borderless={true}
          inputDisabled={true}
          inputStyle={{ backgroundColor: 'transparent', fontWeight: 500, fontSize: '18px' }}
          style={{ marginLeft: '5px', width: '80px' }}
          data-id="level"
          data={[{ level: 'Gold' }, { level: 'Silver' }, { level: 'Bronze' }]}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tag3Text
          text="Financial Year"
          accent="title"
          textStyle={{ marginLeft: 'auto', fontSize: '18px', fontWeight: 500 }}
        />
        <TagCombobox
          textField="year"
          valueField="year"
          value="2018"
          borderless={true}
          inputDisabled={true}
          inputStyle={{
            backgroundColor: 'transparent',
            fontSize: '28px',
            fontWeight: 700,
            marginTop: '-8px',
          }}
          style={{ marginLeft: '5px', width: '70px' }}
          data-id="year"
          data={[{ year: '2018' }, { year: '2017' }, { year: '2016' }]}
        />
      </div>
    </div>
</Tag3AppHeader>`,
    knobs: v3Knobs,
  },
};

const CustomIconStory: Story = {
  title: 'Custom icon',
  description: 'An app header with a custom icon',
  coreComponent: {
    html: `<tag-app-header heading='Quotations' accent='midnightblue' icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMjHxIGmVAAAB20lEQVRIS82WS0sCUQCF+12lZknRAyKSXrSryYroAUFl1ioqiwyKHotaVPSC3q0spaCi0DYSuMhFUK60NFMyQe00d5yhIe/cChQ68MHMnXvOmbnDDDcnT900k6viEnlqDplEzJzOyVU1ZTxcgmTzT0C/mCn+ZwFnGIE6v5l67Tt/KijQteHw6BxEbvc9Grlh6jw5vy6oqTPi7u5BCJeUTCaxt3+G4pIOqofwq4J+4ywikagYm676hkGqj8As0GhbsL5hxceHmETR09MLVBq6n6BYUFLWCZfLI8akZLM5cMIjl83uoPolFAtq6wbEiJSen0PCuErTjFAoIo4C4xOraV45igW6onb+JX6tTTj8horKHlim1vkl+xqvqTVS/RKKBeROSaik+YUd2O1O8Swlny/AXH8C8yV7PI9CkNfrQ2e3RTiWy2q9pvrkMAsuLl1C0IBpLu0bSCSSMA0tUH1ymAW7e6dw3rgxZl4WY4FoNIbtbTv01X1Uz3eYBZtbxzANziMQeEUwGMbi0gFKy7uoc5VQLDC0jAofWDwex6RlTfgP0eb9hGJBlb4Xfn8Q0fcYrq5vFTGPr1D9Eswl0mgN0Ba2MiFzaF4JZkEmyH5BNnYUEiSbf4Jsblu46U+8OOmg+UaF3AAAAABJRU5ErkJggg=='>
      <div slot='menu'>
        <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>`,
  },
  reactWrapper: {
    jsx: `<TagAppHeader
      heading='Quotations'
      accent='midnightblue'
      icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMjHxIGmVAAAB20lEQVRIS82WS0sCUQCF+12lZknRAyKSXrSryYroAUFl1ioqiwyKHotaVPSC3q0spaCi0DYSuMhFUK60NFMyQe00d5yhIe/cChQ68MHMnXvOmbnDDDcnT900k6viEnlqDplEzJzOyVU1ZTxcgmTzT0C/mCn+ZwFnGIE6v5l67Tt/KijQteHw6BxEbvc9Grlh6jw5vy6oqTPi7u5BCJeUTCaxt3+G4pIOqofwq4J+4ywikagYm676hkGqj8As0GhbsL5hxceHmETR09MLVBq6n6BYUFLWCZfLI8akZLM5cMIjl83uoPolFAtq6wbEiJSen0PCuErTjFAoIo4C4xOraV45igW6onb+JX6tTTj8horKHlim1vkl+xqvqTVS/RKKBeROSaik+YUd2O1O8Swlny/AXH8C8yV7PI9CkNfrQ2e3RTiWy2q9pvrkMAsuLl1C0IBpLu0bSCSSMA0tUH1ymAW7e6dw3rgxZl4WY4FoNIbtbTv01X1Uz3eYBZtbxzANziMQeEUwGMbi0gFKy7uoc5VQLDC0jAofWDwex6RlTfgP0eb9hGJBlb4Xfn8Q0fcYrq5vFTGPr1D9Eswl0mgN0Ba2MiFzaF4JZkEmyH5BNnYUEiSbf4Jsblu46U+8OOmg+UaF3AAAAABJRU5ErkJggg=='
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
  },
  coreComponent_v3: {
    html: `<tag3-app-header heading='Quotations' accent='midnightblue' icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMjHxIGmVAAAB20lEQVRIS82WS0sCUQCF+12lZknRAyKSXrSryYroAUFl1ioqiwyKHotaVPSC3q0spaCi0DYSuMhFUK60NFMyQe00d5yhIe/cChQ68MHMnXvOmbnDDDcnT900k6viEnlqDplEzJzOyVU1ZTxcgmTzT0C/mCn+ZwFnGIE6v5l67Tt/KijQteHw6BxEbvc9Grlh6jw5vy6oqTPi7u5BCJeUTCaxt3+G4pIOqofwq4J+4ywikagYm676hkGqj8As0GhbsL5hxceHmETR09MLVBq6n6BYUFLWCZfLI8akZLM5cMIjl83uoPolFAtq6wbEiJSen0PCuErTjFAoIo4C4xOraV45igW6onb+JX6tTTj8horKHlim1vkl+xqvqTVS/RKKBeROSaik+YUd2O1O8Swlny/AXH8C8yV7PI9CkNfrQ2e3RTiWy2q9pvrkMAsuLl1C0IBpLu0bSCSSMA0tUH1ymAW7e6dw3rgxZl4WY4FoNIbtbTv01X1Uz3eYBZtbxzANziMQeEUwGMbi0gFKy7uoc5VQLDC0jAofWDwex6RlTfgP0eb9hGJBlb4Xfn8Q0fcYrq5vFTGPr1D9Eswl0mgN0Ba2MiFzaF4JZkEmyH5BNnYUEiSbf4Jsblu46U+8OOmg+UaF3AAAAABJRU5ErkJggg=='>
      <div slot='menu'>
        <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag3-app-header>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader
      heading='Quotations'
      accent='midnightblue'
      icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMjHxIGmVAAAB20lEQVRIS82WS0sCUQCF+12lZknRAyKSXrSryYroAUFl1ioqiwyKHotaVPSC3q0spaCi0DYSuMhFUK60NFMyQe00d5yhIe/cChQ68MHMnXvOmbnDDDcnT900k6viEnlqDplEzJzOyVU1ZTxcgmTzT0C/mCn+ZwFnGIE6v5l67Tt/KijQteHw6BxEbvc9Grlh6jw5vy6oqTPi7u5BCJeUTCaxt3+G4pIOqofwq4J+4ywikagYm676hkGqj8As0GhbsL5hxceHmETR09MLVBq6n6BYUFLWCZfLI8akZLM5cMIjl83uoPolFAtq6wbEiJSen0PCuErTjFAoIo4C4xOraV45igW6onb+JX6tTTj8horKHlim1vkl+xqvqTVS/RKKBeROSaik+YUd2O1O8Swlny/AXH8C8yV7PI9CkNfrQ2e3RTiWy2q9pvrkMAsuLl1C0IBpLu0bSCSSMA0tUH1ymAW7e6dw3rgxZl4WY4FoNIbtbTv01X1Uz3eYBZtbxzANziMQeEUwGMbi0gFKy7uoc5VQLDC0jAofWDwex6RlTfgP0eb9hGJBlb4Xfn8Q0fcYrq5vFTGPr1D9Eswl0mgN0Ba2MiFzaF4JZkEmyH5BNnYUEiSbf4Jsblu46U+8OOmg+UaF3AAAAABJRU5ErkJggg=='
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
  },
};

const OptionsStory: Story = {
  title: 'Options',
  description: 'An app header with options',
  coreComponent: {
    html: `<tag-app-header
      heading='Docs'
      icon='DocPDF'
      accent='atoll'
      option-1='Filter'
      option-1-icon='Filter'
      option-2-icon='DocAdd'
      data-1='25 Quotations'
      data-1-icon='ItemList'>
      <div slot='menu'>
        <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>`,
  },
  reactWrapper: {
    jsx: `<TagAppHeader
      heading='Docs'
      icon='DocPDF'
      accent='atoll'
      option1='Filter'
      option1Icon='Filter'
      option2Icon='DocAdd'
      data1='25 Quotations'
      data1Icon='ItemList'
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
  },
  coreComponent_v3: {
    html: `<tag3-app-header
      heading='Docs'
      icon='DocPDF'
      accent='atoll'
      option-1='Filter'
      option-1-icon='Filter'
      option-2-icon='DocAdd'
      data-1='25 Quotations'
      data-1-icon='ItemList'>
      <div slot='menu'>
        <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag3-menu-item>
      </div>
    </tag3-app-header>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader
      heading='Docs'
      icon='DocPDF'
      accent='atoll'
      option1='Filter'
      option1Icon='Filter'
      option2Icon='DocAdd'
      data1='25 Quotations'
      data1Icon='ItemList'
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
  },
};

const SubMenusStory: Story = {
  title: 'Sub menus',
  description: 'An app header with a mennu that has a sub menu',
  coreComponent: {
    html: `<tag-app-header
      heading='Customers'
      icon='Users'
      accent='mojo'>
      <div slot='menu'>
        <tag-menu-item name="filter" icon='Filter' text='Filter' is-submenu submenu-position='left-start'>
          <tag-menu-item name="filterAll" text='All'></tag-menu-item>
          <tag-menu-item name="filterStars" text='Stars'></tag-menu-item>
          <tag-menu-item name="filterOnStop" text='On stop'></tag-menu-item>
        </tag-menu-item>
        <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>`,
  },
  reactWrapper: {
    jsx: `<TagAppHeader
      heading='Customers'
      icon='Users'
      accent='mojo'
      menuItems={[
        {
          icon: 'Filter',
          name: 'filter',
          text: 'Filter',
          isSubmenu: true,
          nestedItems: [{
            name: "filterAll",
            text: "All"
          }, {
            name: "filterStars",
            text: "Stars"
          }, {
            name: "filterOnStop",
            text: "On stop"
          }],
          submenuPosition:'left-start',
        },
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
  },
  coreComponent_v3: {
    html: `<tag3-app-header
      heading='Customers'
      icon='Users'
      accent='mojo'>
      <div slot='menu'>
        <tag3-menu-item name='approve' icon='Tick' text='Approve' is-submenu submenu-position='left-start'>
          <tag3-menu-item name='approveThis' text='This item'></tag3-menu-item>
          <tag3-menu-item name='approveAll' text='All items'></tag3-menu-item>
        </tag3-menu-item>
        <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag3-menu-item>
      </div>
    </tag3-app-header>
    `,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader
      heading='Customers'
      icon='Users'
      accent='mojo'
      menuItems={[
        {
          icon: 'Filter',
          name: 'filter',
          text: 'Filter',
          isSubmenu: true,
          nestedItems: [{
            name: "filterAll",
            text: "All"
          }, {
            name: "filterStars",
            text: "Stars"
          }, {
            name: "filterOnStop",
            text: "On stop"
          }],
          submenuPosition:'left-start',
        },
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />`,
  },
};

const DynamicMenusStory: Story = {
  title: 'Dynamic menu',
  description: 'An app header with a menu that is populated at runtime',
  coreComponent: {
    html: `<tag-app-header
      heading='Usage'
      icon='UserF'
      accent='finn'>
      <div slot='menu'>
        <tag-menu-item name="database" icon='Filter' text='Customer' is-submenu submenu-position='left-start'></tag-menu-item>
        <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>`,
    js: `function getMenuItems() {
      return ["Tesco", "Asda", "Morrisons"];
    }
    function addMenuItem(text) {
      var dbMenu = document.querySelector("tag-menu-item[name='database']");
      var subMenu = document.createElement("tag-menu-item");
      subMenu.text = text;
      dbMenu.appendChild(subMenu)
    }
    getMenuItems().forEach(addMenuItem);
    `,
  },
  reactWrapper: {
    parentJSX: `Example = () => {
    const getMenuItems = () => ["Tesco", "Asda", "Morrisons"];
    const [menuItemsFromDb, setMenuItemsFromDb] = React.useState([]);
    React.useEffect(() => {
      setMenuItemsFromDb(getMenuItems())
    }, [])
    return (
      <TagAppHeader
        heading='Usage'
        icon='UserF'
        accent='finn'
        menuItems={[
          {
            icon: 'Filter',
            name: 'database',
            text: 'Filter',
            isSubmenu: true,
            nestedItems: menuItemsFromDb.map(m => ({name: m, text: m})),
            submenuPosition:'left-start',
          },
          {
            icon: 'Delete',
            name: 'remove',
            text: 'Remove',
          },
        ]}
      />
    )
  };`,
    jsx: `<Example />`,
  },
  coreComponent_v3: {
    html: `<tag3-app-header
      heading='Usage'
      icon='UserF'
      accent='finn'>
      <div slot='menu'>
        <tag3-menu-item name="database" icon='Filter' text='Customer' is-submenu submenu-position='left-start'></tag3-menu-item>
        <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag3-menu-item>
      </div>
    </tag3-app-header>
    <p id="loaded">Loading...</p>`,
    js: `function getMenuItems() {
      return ["Tesco", "Asda", "Morrisons"];
    }

    var dbMenu = document.querySelector("tag3-menu-item[name='database']");

    function addMenuItem(text) {
      var subMenu = document.createElement("tag3-menu-item");
      subMenu.text = text;
      dbMenu.appendChild(subMenu)
    }

    setTimeout(function() {
      if(dbMenu.children.length < 2) {
        getMenuItems().forEach(addMenuItem);
        document.getElementById('loaded').innerHTML = 'Loaded';
      }

    },2000);
    `,
  },
  reactWrapper_v3: {
    parentJSX: `Example = () => {
    const getMenuItems = () => ["Tesco", "Asda", "Morrisons"];
    const [menuItemsFromDb, setMenuItemsFromDb] = React.useState([]);
    const [loaded, setLoaded] = React.useState(false);
    React.useEffect(() => {
      setTimeout(() => {
        setMenuItemsFromDb(getMenuItems())
        setLoaded(true)
      },2000)
    }, [])
    return (
      <div>
        <Tag3AppHeader
          heading='Usage'
          icon='UserF'
          accent='finn'
          menuItems={[
            {
              icon: 'Filter',
              name: 'database',
              text: 'Filter',
              isSubmenu: true,
              nestedItems: menuItemsFromDb.map(m => ({name: m, text: m})),
              submenuPosition:'left-start',
            },
            {
              icon: 'Delete',
              name: 'remove',
              text: 'Remove',
            },
          ]}
        />
        <p>
          {loaded ? 'Loaded' : 'Loading...'}
        </p>
      </div>
    )
  };`,
    jsx: `<Example />`,
  },
};

const customStylesKnobs: Knobs = {
  heading: {
    default: 'Onboarding',
    editor: 'textbox',
  },
  headingAccent: {
    default: 'white',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  accent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  icon: {
    default: 'Briefcase',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  iconAccent: {
    default: 'gulfstream',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  menuButtonIconAccent: {
    default: 'white',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  containerStyle: {
    editor: 'textbox',
    default: '{"background-color": "#3F8C89", "border-top-color": "#33706e"}',
  },
};

const CustomStylesStory: Story = {
  title: 'Custom Styles',
  description: 'A single app header',
  coreComponent: {
    html: `<tag-app-header{{...knobs}}>
      <div slot='menu'>
        <tag-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>`,
    knobs: customStylesKnobs,
  },
  reactWrapper: {
    jsx: `<TagAppHeader
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
      {{...knobs}}
    />`,
    knobs: {
      ...customStylesKnobs,
      containerStyle: {
        ...customStylesKnobs.containerStyle,
        qualifierEnd: '}',
        qualifierStart: '{',
      },
    },
  },
  coreComponent_v3: {
    html: `<tag3-app-header{{...knobs}}>
      <div slot='menu'>
       <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag3-app-header>`,
    knobs: customStylesKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
      {{...knobs}}
    />`,
    knobs: {
      ...customStylesKnobs,
      containerStyle: {
        ...customStylesKnobs.containerStyle,
        qualifierEnd: '}',
        qualifierStart: '{',
      },
    },
  },
};

const OptionsSlotStory: Story = {
  description: 'App header using custom options slot content',
  title: 'Options Slot',
  coreComponent_v3: {
    html: `
<tag3-app-header
  heading='Custom Options'
  accent="dolphinblue"
  icon='Search'>
    <div slot="options" style="display: flex;">
      <tag3-app-header-option
        name="CustomOption1"
        type="button"
        text='Custom Option 1'
        accent="access"
        icon="Access"
      ></tag3-app-header-option>
      <tag3-app-header-option-separator></tag3-app-header-option-separator>
    </div>
    <div slot='menu'>
      <tag3-menu-item name="remove" icon='Delete' text='Remove'></tag3-menu-item>
    </div>
</tag3-app-header>
    `,
  },
  reactWrapper_v3: {
    jsx: `<Tag3AppHeader
    heading='Custom Options'
    icon='Search'
    accent='dolphinblue'
    menuItems={[
      {
        icon: 'Delete',
        name: 'remove',
        text: 'Remove',
      },
    ]}
    renderOptions={() =>
      <div style={{display: 'flex'}}>
        <Tag3AppHeaderOption
        name="CustomOption1"
        type="button"
        text='Custom Option 1'
        accent="access"
        icon="Access"/>
        <Tag3AppHeaderOptionSeparator />
      </div>
    }

  />`,
  },
};

export const TagAppHeaderDocs: Component = {
  type: 'component',
  name: 'app-header',
  description: 'Renders a workspace widget app header',
  mobileFriendly: false,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'accent',
      description: 'The accent colour for top border of the header as well as the icon',
      type: 'string',
      default: 'transparent',
    },
    {
      name: 'icon',
      description: 'The icon to show in the top left. Can also be an image url reference',
      type: 'string',
    },
    {
      name: 'heading',
      description: 'The title of the app',
      type: 'string',
    },
    {
      name: 'headingAccent',
      description: 'The accent colour of the heading',
      type: 'string',
      default: 'title',
    },
    {
      name: 'option1',
      description: 'The text to display for the option button',
      type: 'string',
      default: '',
    },
    {
      name: 'option1IconAccent',
      description: 'V3 only: The icon to display to the left of the option text',
      type: 'string',
      default: '',
    },
    {
      name: 'option1Accent',
      description: 'The icon accent. Deprecated in v3',
      type: 'string',
      default: 'title',
    },
    {
      name: 'option2',
      description: 'The text to display for the option button',
      type: 'string',
      default: '',
    },
    {
      name: 'option2IconAccent',
      description: 'V3 only: The icon to display to the left of the option text',
      type: 'string',
      default: '',
    },
    {
      name: 'option2Accent',
      description: 'The icon accent. Deprecated in v3',
      type: 'string',
      default: 'title',
    },
    {
      name: 'data1',
      description: 'The text to display',
      type: 'string',
      default: '',
    },
    {
      name: 'data1Icon',
      description: 'The icon to display to the left of the option text',
      type: 'string',
      default: '',
    },
    {
      name: 'data1IconAccent',
      description: 'Only v3: The icon accent',
      type: 'string',
      default: 'title',
    },
    {
      name: 'data1Accent',
      description: 'The icon accent. Deprecated in V3',
      type: 'string',
      default: 'title',
    },
    {
      name: 'data2',
      description: 'The text to display',
      type: 'string',
      default: '',
    },
    {
      name: 'data2Icon',
      description: 'The icon to display to the left of the option text',
      type: 'string',
      default: '',
    },
    {
      name: 'data2IconAccent',
      description: 'Only v3: The icon accent',
      type: 'string',
      default: 'title',
    },
    {
      name: 'data2Accent',
      description: 'The icon accent. Deprecated in V3',
      type: 'string',
      default: 'title',
    },
    {
      name: 'containerStyle',
      description: 'JSX style object in JSON to apply to the header ',
      type: 'string',
      default: '',
    },
    {
      name: 'menuButtonIconAccent',
      description: 'The accent colour for menu button',
      type: 'string',
      default: '',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'optionClick',
      description:
        'Triggers when an option button is clicked in the header bar (not the menu options)',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the option button',
          type: 'string',
        },
        {
          name: 'text',
          description: 'The text attribute of the option button',
          type: 'string',
        },
      ],
    },
    {
      name: 'menuItemClick',
      description: 'Triggers when a menu item clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the menu item',
          type: 'string',
        },
        {
          name: 'text',
          description: 'The text attribute of the menu item',
          type: 'string',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'showMenu',
      description: 'Shows the menu',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'hideMenu',
      description: 'Hides the menu',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'toggleMenu',
      description: 'Shows / hides the menu',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    SingleStory,
    DoubleStory,
    CustomIconStory,
    OptionsStory,
    SubMenusStory,
    DynamicMenusStory,
    CustomStylesStory,
    OptionsSlotStory,
  ],
};
